import { combineReducers } from 'redux';
import qualifications from './qualification.reducer';

const qualificationAppReducer = combineReducers({
    qualifications
});

export default qualificationAppReducer;


// WEBPACK FOOTER //
// src/main/content/qualification/store/reducers/index.js